import React from "react";
import { Stack } from "@mui/material";
import { useFieldArray } from "react-hook-form";

import LaborMaterialsTableHeader from "./LaborMaterialsTableHeader";
import LaborMaterialsTableBody from "./LaborMaterialsTableBody";
import LaborMaterialsTableAddRow from "./LaborMaterialsTableAddRow";

export const LaborMaterialsTable = ({ laborId }) => {
  const fieldArrayOptions = useFieldArray({
    name: "laborMaterials",
  });
  const { append, fields, remove } = fieldArrayOptions;

  const handleAdd = (defaultValues = {}) =>
    append({
      laborId,
      materialId: null,
      quantity: 0,
      ...defaultValues,
    });

  const props = { handleAdd, remove, fields };

  return (
    <Stack overflowX="auto" width="100%" maxWidth="630px">
      <LaborMaterialsTableHeader />
      <LaborMaterialsTableBody {...props} />
      <LaborMaterialsTableAddRow handleAdd={handleAdd} />
    </Stack>
  );
};

export default LaborMaterialsTable;
